import React, { useState } from 'react';

type Props = {};

const EditProfilePage = (props: Props) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyAddress: '',
    taxId: '',
    subscribeEmail: false,
    balanceNotificationLimit: 20,
    dailyBudgetDepletion: false,
    password: '',
    isHuman: false,
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;

    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form Submitted:', formData);
  };


  const inputStyle = {
    width: '100%',
    padding: '8px',
    marginBottom: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '10px',
  };

  const buttonStyle = {
    padding: '5px 40px',
    border: 'none',
    borderRadius: '0px',
    cursor: 'pointer',
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#1173B7',
    color: 'white',
    fontSize:'12px'
  };

  const dangerButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'red',
    color: 'white',
    fontSize:'10px'
  };

  return (
    <div style={{ padding: '30px', height: '90%', width: '60%', boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)' }} >


      <div style={{ textAlign: 'left' }}>
        <h2 style={{ fontSize: '12px' }}>Edit Account Details</h2>
        <form onSubmit={handleSubmit}>


          <div style={{ display: 'flex' }}>
            {/* First Name and Last Name */}
            <div style={{ display: 'grid', gap: '20px', marginBottom: '15px' }}>
              <div style={{ flex: 1 }}>
                <label htmlFor="firstName" style={{ fontSize: '12px' }}>
                  First Name:  <span style={{ color: 'red', fontSize: '10px' }}>* Required Field</span>
                </label>
                <input
                  id="firstName"
                  type="text"
                  name="firstName"

                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                  placeholder="First Name"
                  style={inputStyle}
                  aria-label="First Name"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label htmlFor="lastName" style={{ fontSize: '12px' }}>
                  Last Name: <span style={{ color: 'red', fontSize: '10px' }}>* Required Field</span>
                </label>
                <input
                  id="lastName"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                  placeholder="Last Name"
                  style={inputStyle}
                  aria-label="Last Name"
                />
              </div>
              {/* Email Address */}
              <div style={{ marginBottom: '15px' }}>
                <label htmlFor="email">
                  Email Address: <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="Email Address"
                  style={inputStyle}
                  aria-label="Email Address"
                />
              </div>
            </div>




            {/* Company Name and Tax ID */}
            <div style={{ display: 'grid', gap: '20px', marginBottom: '15px', marginLeft: '120px' }}>
              <div style={{ flex: 2 }}>
                <label htmlFor="companyAddress">
                  Company Name and Address (for invoicing):{' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
                <textarea
                  id="companyAddress"
                  name="companyAddress"
                  value={formData.companyAddress}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter company address"
                  style={{ ...inputStyle, height: '100px' }}
                  aria-label="Company Address"
                ></textarea>
              </div>
              <div style={{ flex: 1 }}>
                <label htmlFor="taxId">
                  Tax ID: <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  id="taxId"
                  type="text"
                  name="taxId"
                  value={formData.taxId}
                  onChange={handleInputChange}
                  required
                  placeholder="Tax ID"
                  style={inputStyle}
                  aria-label="Tax ID"
                />
              </div>
            </div>
          </div>


          {/* Email Notifications */}
          <div style={{ marginBottom: '15px',fontSize:'12px' }}>
            <label>
              <input
                type="checkbox"
                name="subscribeEmail"
                checked={formData.subscribeEmail}
                onChange={handleInputChange}
                aria-label="Subscribe to Email Notifications"
              />{' '}
              Subscribe to the Advertiser Email Notifications
            </label>
          </div>

          {/* Notification Subscriptions */}
          <fieldset
            style={{
              fontSize:'12px',
              border: '1px solid #ddd',
              padding: '10px',
              marginBottom: '15px',
            }}
          >
            <legend>Email Notifications Subscriptions:</legend>
            <div style={{ marginBottom: '10px',fontSize:'12px', }}>
              <label>
                <input
                  type="checkbox"
                  name="dailyBudgetDepletion"
                  checked={formData.dailyBudgetDepletion}
                  onChange={handleInputChange}
                  aria-label="Daily Budget Depletion Notification"
                />{' '}
                Daily ad budget depletion
              </label>
            </div>
            <div>
              <label>
                Balance Notification Limit: US$
                <input
                  type="number"
                  name="balanceNotificationLimit"
                  value={formData.balanceNotificationLimit}
                  onChange={handleInputChange}
                  style={{ width: '60px', marginLeft: '10px' }}
                  min="1"
                  aria-label="Balance Notification Limit"
                />
              </label>
            </div>
          </fieldset>

          {/* CAPTCHA */}
          <div style={{ marginBottom: '15px',fontSize:'12px', }}>
            <label>
              <input
                type="checkbox"
                name="isHuman"
                checked={formData.isHuman}
                onChange={handleInputChange}
                aria-label="I am not a robot"
              />{' '}
              I'm not a robot
            </label>
          </div>

          {/* Password */}
          <div style={{ marginBottom: '15px',fontSize:'12px', }}>
            <label htmlFor="password">Password:</label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Password"
              style={inputStyle}
              aria-label="Password"
            />
          </div>

          {/* Update Button */}
          <div style={{width:'90%',textAlign:'center'}}>
            <button
              type="submit"
              style={primaryButtonStyle}
              aria-label="Update Profile"
            >
              Update
            </button>
          </div>
        </form>

        {/* Account Closure */}
        <div
          style={{
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid #ddd',
            fontSize:'12px',
          }}
        >
          <h3>Account Closure:</h3>
          <p>
            If you wish to close your account permanently and delete its entire
            data - click the button below.
          </p>
          <button style={dangerButtonStyle} aria-label="Delete Account">
            Delete all of my personal data and close my account
          </button>
        </div>
      </div>


    </div>

  );
};

export default EditProfilePage;
